import { Badge } from "../components/ui/badge";
import { Card, CardContent } from "../components/ui/card";

const Partners = () => {
  const partners = [
    { name: "SunPower", category: "Premium Solar Panels" },
    { name: "Tesla Energy", category: "Energy Storage" },
    { name: "Enphase", category: "Microinverters" },
    { name: "SolarEdge", category: "Power Optimizers" },
    { name: "Canadian Solar", category: "Solar Modules" },
    { name: "Fronius", category: "String Inverters" },
    { name: "REC Group", category: "High-Efficiency Panels" },
    { name: "LG Solar", category: "Premium Technology" }
  ];

  const certifications = [
    { name: "NABCEP Certified", description: "North American Board of Certified Energy Practitioners" },
    { name: "SEIA Member", description: "Solar Energy Industries Association" },
    { name: "Better Business Bureau A+", description: "Highest Rating for Business Excellence" },
    { name: "EPA Green Power Partner", description: "Environmental Protection Agency Recognition" }
  ];

  return (
    <section id="partners" className="py-20 bg-gradient-to-b from-background to-solar-light-blue">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <Badge variant="outline" className="mb-4 border-primary text-primary">
            Our Partners
          </Badge>
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 bg-gradient-solar bg-clip-text text-transparent">
            Trusted Industry Partners
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            We collaborate with the world's leading solar technology manufacturers to deliver the highest quality solutions.
          </p>
        </div>

        <div className="mb-20">
          <h3 className="text-2xl font-bold text-center mb-12 text-foreground">
            Technology Partners
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {partners.map((partner, index) => (
              <Card key={index} className="border-0 shadow-card-solar hover:shadow-solar transition-all duration-300 hover:-translate-y-1">
                <CardContent className="p-6 text-center">
                  <div className="w-16 h-16 bg-gradient-solar rounded-lg flex items-center justify-center mx-auto mb-4">
                    <div className="text-primary-foreground font-bold text-lg">
                      {partner.name.charAt(0)}
                    </div>
                  </div>
                  <h4 className="font-bold text-primary mb-2">{partner.name}</h4>
                  <p className="text-sm text-muted-foreground">{partner.category}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-2xl font-bold text-center mb-12 text-foreground">
            Certifications & Memberships
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {certifications.map((cert, index) => (
              <Card key={index} className="border-0 shadow-card-solar hover:shadow-solar transition-all duration-300">
                <CardContent className="p-6 text-center">
                  <div className="w-20 h-20 bg-gradient-energy rounded-full flex items-center justify-center mx-auto mb-4">
                    <div className="text-primary-foreground font-bold text-2xl">✓</div>
                  </div>
                  <h4 className="font-bold text-primary mb-3">{cert.name}</h4>
                  <p className="text-sm text-muted-foreground leading-relaxed">{cert.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;